import { Box, Button, Heading, Text } from '@chakra-ui/react';
import { ArrowLeft } from 'iconoir-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NAV_DARK_FOCUS_RING } from '../layout/nav-dark';

interface SidebarPanelHeaderProps {
  title: React.ReactNode;
  onBack?: () => void;
}

/**
 * Header for the internal sliding panels (Settings / Conversations / Program):
 * a small "Back" link that returns to the main navigation, above the panel title.
 */
const SidebarPanelHeader: React.FC<SidebarPanelHeaderProps> = ({ title, onBack }) => {
  const { t } = useTranslation();

  return (
    <Box>
      {onBack && (
        <Button
          type="button"
          variant="plain"
          onClick={onBack}
          display="inline-flex"
          alignItems="center"
          gap="7px"
          mt="-2px"
          mb="10px"
          ml="-4px"
          px="8px"
          py="5px"
          h="auto"
          minW="auto"
          rounded="8px"
          fontFamily="heading"
          fontSize="12.5px"
          fontWeight={500}
          color="navDark.textMuted"
          transition="background-color .12s, color .12s"
          _hover={{ color: 'navDark.textStrong', bg: 'navDark.hoverBg' }}
          _focusVisible={NAV_DARK_FOCUS_RING}
        >
          <ArrowLeft width={15} height={15} strokeWidth={2} />
          <Text>{t('common.back')}</Text>
        </Button>
      )}
      <Box mx="9px">
        {typeof title === 'string' ? (
          <Heading
            as="h2"
            fontFamily="heading"
            fontSize="21px"
            fontWeight={700}
            letterSpacing="-0.01em"
            color="navDark.textStrong"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            title={title}
          >
            {title}
          </Heading>
        ) : (
          title
        )}
      </Box>
    </Box>
  );
};

export default SidebarPanelHeader;
